import { Box, Stack, useTheme } from '@mui/material'
import { grey } from '@mui/material/colors'
import { makeStyles } from '@mui/styles'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import Inventory from '../../../../../../api/db/Inventory'
import pubsub from '../../../../../../modules/pubsub'
import { selectCurrrentAdminShop } from '../../../../../../store/features/currentBusinessShop'
import { selectUserPropsState } from '../../../../../../store/features/user'
import Modal from '../../../../../molecules/Modal'
import DashboardTable from '../../../../../organisms/DashboardTable'
import BodySkeleton from '../../../../common/skeletons/BodySkeleton'
import UpdateProductForm from '../forms/UpdateProductForm'


const tbodyData = [
    {
        name: "Chicken Wings (Henwings)",
        brand: "Unknwon",
        cartons: 1.95,
        kilos_per_carton: 10,
        costprice_per_carton: 195,
        sellingprice_per_carton: 240,
        sellingprice_per_kilo: 25,
        carton_type: "10Kg/C",
    },
    {
        name: "Soft Chicken Thigh (CLQ)",
        brand: "Unknwon",
        cartons: 52.5,
        kilos_per_carton: 10,
        costprice_per_carton: 100,
        sellingprice_per_carton: 190,
        sellingprice_per_kilo: 20,
        carton_type: "10Kg/C",
    },
    {
        name: "Gizzard Packed",
        brand: "Unknwon",
        cartons: 109.5,
        kilos_per_carton: 12,
        costprice_per_carton: 80,
        sellingprice_per_carton: 125,
        sellingprice_per_kilo: 13,
        carton_type: "10Kg/C",
    },
]


export default function ContentBody() {

    const user_id = useSelector(selectUserPropsState)?.uid
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [openedItem] = useState<any>({}) 
    const [loading, setLoading] = useState(true)
    const theme = useTheme()
    const current_shop = useSelector(selectCurrrentAdminShop)?.name
    // const [products, setProducts] = useState([])
    
    useEffect(()=>{

        pubsub.on("inventory:changed",getProducts)
        getProducts()

        return ()=>pubsub.off("inventory:changed", getProducts)

    // eslint-disable-next-line
    },[])

    const getProducts = async ()=>{

        try {

            setLoading(true)
            await Inventory.getProducts(user_id!, current_shop!)
            setLoading(false)
            
        } catch (error) {
            setLoading(false)
            throw error            
        }
        
    }

    const handleOnDone = ()=>{

        setIsModalOpen(false)
        pubsub.trigger("inventory:changed")
        
    }
    

    const useStyles = makeStyles({
        content:{
            flex: 1, 
            border: `.5px solid rgba(255, 255, 255, 0.1)`,
            borderRadius: "4px", 
            minHeight: "420px", 
            backgroundColor: theme.palette.primary.main,
            padding: "1rem"
        },
        searchField:{
            backgroundColor: theme.palette.primary.dark,
            border: `.5px solid rgba(255, 255, 255, 0.1)`,
            padding: ".3rem",
            borderRadius: "3px",
            color: grey[200],
            fontWeight: "regular",
            fontSize: "14px",
            outline: "none"
        }
    })

    const classes = useStyles()
    
    return (
        <>
            {
                loading ? (
                    <BodySkeleton />
                ):(

                    <Box className={classes.content} >

                        <Stack
                            sx={{height: "100%"}}
                            direction="column"
                            spacing={2}
                        >
                            <DashboardTable 
                                title={"Cold room"}
                                tableHeaders={{name:"name", brand:"brand", cartons:"cartons", kilos_per_carton: "kilos_per_carton", costprice_per_carton:"costprice_per_carton", sellingprice_per_carton:"sellingprice_per_carton", sellingprice_per_kilo:"selling_price_Kilos", carton_type:"carton_type"}}
                                tableItems={tbodyData}
                                itemsUniqueKey={"name"}
                                itemsPerPage={15}
                                onItemClick={()=>{}}
                                onItemsDelete={()=>{}}
                                onItemsPerPageChange={()=>{}}
                                onNextPage={()=>{}}
                                onPrevPage={()=>{}}
                            />

                        </Stack>

                        
                    </Box>
                    
                )
            }

            <Modal
                title={"Product detail"}
                subtitle={openedItem?.name}
                visible={isModalOpen}
                setVisibility={setIsModalOpen}
            >
                <UpdateProductForm
                    onDelete={handleOnDone}
                    onDeleteFail={()=>{
                        toast(`Failed to update ${openedItem.name}. Please try again later`,{
                            type: "error",
                            hideProgressBar: true,
                            theme: "dark",
                            position: "top-center"
                        })
                    }}
                    onUpdate={handleOnDone}
                    onUpdateFail={()=>{
                        toast(`Failed to update ${openedItem.name}. Please try again later`,{
                            type: "error",
                            hideProgressBar: true,
                            theme: "dark",
                            position: "top-center"
                        })
                    }}
                    item_data={openedItem}
                />

            </Modal>
        </>
    )
}
